import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-field",
  id: "frm_estateFilter-adType-form-field"
}
const _hoisted_2 = { class: "form-label" }
const _hoisted_3 = { class: "buttons-group" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  id: "frm_estateFilter-estateSubType-form-field",
  class: "form-field"
}
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { class: "multiple-inputs no-gap align-stretch" }
const _hoisted_10 = {
  key: 0,
  class: "selectbox selectbox--country-prefix"
}
const _hoisted_11 = { class: "form-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " ", -1)
const _hoisted_13 = {
  class: "button button--search fullwidth",
  type: "submit"
}
const _hoisted_14 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_GoogleAutocomplete = _resolveComponent("GoogleAutocomplete")!

  return (_openBlock(), _createElementBlock("form", {
    id: "estate-filter",
    class: "filter-form form",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    autocomplete: "off"
  }, [
    (!_ctx.isEstateAgencyMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('AdSearch.filter.adtype')) + ":", 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adTypes, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.key,
                class: _normalizeClass(["button", { 'is-active': _ctx.queryParams.type === item.key, [`adtype-${item.key}`]: true }]),
                type: "button",
                onClick: ($event: any) => (_ctx.selectAdType(item.key))
              }, _toDisplayString(item.value), 11, _hoisted_4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isEstateAgencyMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('AdSearch.filter.estatetype')) + ":", 1),
          _createVNode(_component_multiselect, {
            id: "frm_estateFilter-estateSubType",
            modelValue: _ctx.queryParams.estateFrontSubTypes,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryParams.estateFrontSubTypes) = $event)),
            class: _normalizeClass({ 'is-active': _ctx.queryParams.estateFrontSubTypes && this.queryParams.estateFrontSubTypes.length > 0 }),
            "track-by": "key",
            label: "value",
            "show-labels": false,
            options: _ctx.estateTypes,
            "group-values": "estateSubTypes",
            "group-label": "value",
            placeholder: _ctx.$t('AdSearch.filter.estatetypePlaceholder'),
            "group-select": true,
            searchable: !_ctx.isMobile,
            "close-on-select": true,
            multiple: true,
            "allow-empty": true
          }, {
            noResult: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "class", "options", "placeholder", "searchable"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('AdSearch.filter.location')) + ":", 1),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.isEstateAgencyMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_multiselect, {
                id: "frm_estateFilter-country",
                class: "select--country",
                modelValue: _ctx.country,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.country) = $event)),
                onSelect: _ctx.onCountryChanged,
                "track-by": "key",
                label: "value",
                "show-labels": false,
                options: _ctx.countries,
                searchable: true,
                "close-on-select": true,
                placeholder: "",
                multiple: false,
                "allow-empty": true
              }, {
                singleLabel: _withCtx(({ option }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass('flag-country-' + option.key)
                  }, null, 2)
                ]),
                option: _withCtx(({ option }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass('flag-country-' + option.key)
                  }, null, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'font-weight-bold': option.key === _ctx.defaultCountry.key })
                  }, _toDisplayString(option.value), 3)
                ]),
                noResult: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "onSelect", "options"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_GoogleAutocomplete, {
          ref: "place",
          id: "frm_estateFilter-place",
          name: "frm_estateFilter-place",
          placeholder: _ctx.$t('AdSearch.filter.locationPlaceholder'),
          class: "form-control",
          types: null,
          country: _ctx.country.key,
          onPlacechanged: _ctx.onPlaceChanged,
          modelValue: _ctx.locationFilterText,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.locationFilterText) = $event))
        }, null, 8, ["placeholder", "country", "onPlacechanged", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t('AdSearchHome.search')), 1),
      (_ctx.place && !_ctx.isEstateAgencyMode)
        ? (_openBlock(), _createElementBlock("label", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.$t('AdSearchHome.showInList')) + " ", 1),
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showList) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showList]
            ]),
            _hoisted_15
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}